import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import About from "./views/About.vue";
import Portfolio from "./views/Portfolio.vue";
import Zverg from "./views/Zverg.vue";
import Cravely from "./views/Cravely.vue";
import Upwork from "./views/Upwork.vue";
import Resume from "./views/Resume.vue";

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/about",
      name: "about",
      component: About,
    },
    {
      path: "/portfolio",
      name: "portfolio",
      component: Portfolio,
    },
    {
      path: "/portfolio/zverg",
      name: "zverg",
      component: Zverg,
    },
    {
      path: "/portfolio/cravely",
      name: "cravely",
      component: Cravely,
    },
    {
      path: "/portfolio/upwork",
      name: "upwork",
      component: Upwork,
    },
    {
      path: "/resume",
      name: "resume",
      component: Resume,
    }
  ]
});
